import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import Home from './views/Home.vue'
import SuperUser from './views/SuperUser.vue'
import SystemCon from './views/SystemCon.vue'
import SystemMoni from './views/SystemMoni.vue'
import test from './components/test.vue'

// import Personal from './components/Personal.vue'

Vue.use(Router)


const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/main',
      name: 'main',
      component: Main
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/superuser',
      name: 'superuser',
      component: SuperUser
    },
    
    {
      path: '/systemMoni',
      name: 'systemMoni',
      component: SystemMoni
    },
    {
      path: '/systemCon',
      name: 'systemCon',
      component: SystemCon
    },
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/domain',
      name: 'domain',
      component: () => import(/* webpackChunkName: "domain" */ './views/Domain.vue')
    },

    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  if(to.path=='/home') {
    let currentUser =  JSON.parse(window.sessionStorage.getItem("vuex")).currentUser;
    console.log(currentUser)
    if (currentUser.isOpenSecurity && currentUser.departments.length > 0 && currentUser.domains.length > 0) {
      //当前是部门及的用户，是不允许跳转到home主页的
      alert("当前登陆用户属于部门级用户，没有权限访问主页")
      next(from.path);
    }else{
      next();
    }
  }else{
    next();
  }
})
export default router;